import { useState, useEffect, useMemo } from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';
import Divider from '@material-ui/core/Divider';
import TabPanel from './TabPanel';
import { useDispatch, useSelector } from 'react-redux';
import { transactionEvents } from "../../store/constructs/events/selectors";
import BreadCrumb from '../atoms/breadcrumb/';
import CreateTransaction from '../molecules/transactions/CreateTransaction';
import EditTransaction from '../molecules/transactions/EditTransaction';
import { marginBottomForBreadCrumb } from '../../config/styles';
import EditTransactionNodes from '../molecules/transactions/EditTransactionNodes';
import EventTable from '../molecules/events/EventTable';
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import DeleteTransactionAlert from '../molecules/alerts/DeleteTransactionAlert'
import { handleSnackBar, setFocusElement, toggleRightDrawer } from '../../store/global/actions';
import { enableTabStyle, disableTabStyle } from '../../config/common';
import DeleteTemplatedTransactionAlert from '../molecules/alerts/DeleteTemplatedTransactionAlert';
import UnnestChildTransactionAlert from '../molecules/alerts/UnnestChildTransactionAlert';
import { getBottomDrawerStatus, getDisabledStatus, getLogRedirectionData, getTabOnFocus } from '../../store/global/selectors'
import CancelPresentationIcon from '@material-ui/icons/CancelPresentation';
import { RemapClusterlets } from '../molecules/transactions/RemapClusterlets';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import AdvancedSetup from '../molecules/transactions/AdvancedSetup';
import { useBottomDrawer } from '../../hooks/useBottomDrawer';
import CompactAlert from '../molecules/logs/LogRedirectionAlert';

export default function Transaction({ element, bottomDrawer, onCreateInvokedTransaction }) {
    const dispatch = useDispatch();
    const params = useParams()

    const [action, setAction] = useState(0);
    const [tabActive, setTabActive] = useState(false);
    
    const tabOnFocus = useSelector(getTabOnFocus);
    let isDisabled = useSelector(getDisabledStatus);
    const bottomDrawerStatus = useSelector(getBottomDrawerStatus);

    const bottomDrawerConfig = useBottomDrawer();
      const logRedirectionData = useSelector(getLogRedirectionData)
    const {activeTab: value, setActiveTab: setValue, setTabConfig} = bottomDrawerConfig || {};

    let detailsBC = [
        { label: 'Transactions', url: null }
    ]

    const isMainTransaction = () => {
        let nestedGroups = [9, 19];
        return nestedGroups.includes(element.type) === false;
    }

    if (!isMainTransaction()) {
        detailsBC = [...detailsBC, { label: 'Child transaction', url: null }, { label: element.name, url: null }]
    } else {
        detailsBC = [...detailsBC, { label: element.name, url: null }]
    }

    const isTemplatedTransaction = () => {
        return element.type === 24;
    }

    const isInvokedTransaction = () => {
        return params.transaction !== element.id && element.type !== 9 && action.action !== "create_transaction" && element?.type === 19;
    }

    useEffect(() => {
        if (element.id == null) {
            setAction({ action: 'create_transaction' });
            setTabActive('basic');
            if(bottomDrawer) setValue(0);
        }
        if (element.id != null && !isTemplatedTransaction()) setAction({ action: 'edit_transaction', id: element.id });

    }, [element])

    useEffect(() => {


        if (tabActive === 'nodes') {

            document.getElementById('tab_transaction').style.opacity = disableTabStyle.opacity;
            document.getElementById('tab_transaction').style.borderBottom = disableTabStyle.borderBottom;
            document.getElementsByClassName('MuiTabs-indicator')[0].style.backgroundColor = disableTabStyle.backgroundColor;

            document.getElementById('tab_clusterlet').style.opacity = enableTabStyle.opacity;
            document.getElementById('tab_clusterlet').style.borderBottom = enableTabStyle.borderBottom;


        }
        if (tabActive === 'basic') {

            document.getElementById('tab_transaction').style.opacity = enableTabStyle.opacity;
            document.getElementById('tab_transaction').style.borderBottom = enableTabStyle.borderBottom;
            document.getElementsByClassName('MuiTabs-indicator')[0].style.backgroundColor = enableTabStyle.backgroundColor;


            document.getElementById('tab_clusterlet').style.opacity = disableTabStyle.opacity;
            document.getElementById('tab_clusterlet').style.borderBottom = disableTabStyle.borderBottom;



        }
    }, [tabActive])

    useEffect(() => {
        if(bottomDrawer) setValue(tabOnFocus);
    }, [tabOnFocus])

    const onCompletion = (type, action) => {
        if (action) {
            switch (action) {
                case 'delete':
                    dispatch(handleSnackBar({ open: true, message: `${type} deleted`, severity: "success" }));
                    if (type !== 'Field' && type !== 'Property') {
                        dispatch(setFocusElement(null));
                        dispatch(toggleRightDrawer());
                    }
                    break;

                case 'unnest':
                    dispatch(handleSnackBar({ open: true, message: `${type} unnested`, severity: "success" }));
                    dispatch(toggleRightDrawer());
                    break;
                default:
                    break;
                
            }

            setAction({});
        }else {
            setAction({});
            dispatch(toggleRightDrawer());
        }
    }



    const setDeleteAction = () => {
        if (element.type === 24) {
            setAction({ action: 'delete_temp_transaction' })
        }else {
            setAction({ action: 'delete_transaction' })
        }
    }

    const setUnnestAction = () => {
        setAction({ action: 'unnest_transaction' })
    }

    useMemo(() => {
        const tabs = [
            {
                label: 'setup',
                id: 'tab_edit_transaction',
            }
        ]
        if(isMainTransaction() && action.action !== 'create_transaction'){
            tabs.push({
                label: 'Remap Clusterlets',
                id: "tab_remap_clusterlets",
                isDisabled: element.id == null
            })
        }

        if(!isInvokedTransaction() && action.action !== 'create_transaction'){
            tabs.push({
                label: "advanced",
                id: "tab_advanced_setup",
                isDisabled: element.id == null
            })
        }

        if(bottomDrawer){
            setTabConfig(tabs)
        }
    }, [element])
    return (
        <>
            {
                !bottomDrawer &&
                <AppBar position="static" id='transaction_tabs_wrapper' >
                <Tabs value={value} id='transaction_tabs' onChange={(e, v) => {  if(bottomDrawer)setValue(v); }}>
                    {/* Transaction basic details tab */}
                    <Tab label="Setup"  id='tab_edit_transaction' data-ui-tour-id='transaction-basic-tab'  style={{ color: 'white' }}  />
                    
                    {/* Transactin clusterlets */}
                    {/* {isMainTransaction() && !isInvokedTransaction() && showClusterletsTab && 
                    <Tab label="Clusterlets" disabled={element.id == null}  id='tab_clusterlet'  style={{ color: 'white' }} />} */}

                    {/* Transaction Events tab */}
                    {/* {action.action !== 'create_transaction' && showEventsTab && 
                    <Tab label="Events" id="tab_transaction_events" disabled={element.id == null} />} */}

                    {/* Remap clusterlets tab */}
                    {isMainTransaction() && action.action !== 'create_transaction' && (
                    <Tab label="Remap Clusterlets" id="tab_remap_clusterlets" data-ui-tour-id='remap-clusterlets-tab' disabled={element.id == null} /> )}

                    {/* Advanced setup for main transaction */}
                    {!isInvokedTransaction() && action.action !== 'create_transaction' && (
                    <Tab label="Advanced" id="tab_advanced_setup" data-ui-tour-id='transaction-advanced-tab' disabled={element.id == null} />)}
                </Tabs>
            </AppBar>
            }


            {/* Basic details tab */}
            <TabPanel value={value} index={0}>
                {
                    (logRedirectionData?.entity === "child_transaction" && logRedirectionData.entityId === element.id) ?
                      <CompactAlert severity={logRedirectionData?.level} >{logRedirectionData?.message}</CompactAlert>
                    :
                    null
                
                }
                <Box style={{height: '5px'}} />
                {/* <Grid container direction={"row"} spacing={2}> */}
                {/* Delete and unnest button */}
                {/* {!bottomDrawerStatus && action.action !== 'create_transaction' && ( */}
                {/* Delete and unnest button */}
                {/* <Grid container direction={"row"} spacing={2}>
                    {action.action !== 'create_transaction' && (
                    <Grid container direction={"row"} spacing={2} xs={4} style={{ display: "flex", justifyContent: "flex-end" }}>
                        {!isMainTransaction() &&
                        <Grid item xs={2} >
                            <Tooltip title="Unnest Transaction" arrow>
                                <div style={{ display: 'inline-block' }}>
                                    <IconButton onClick={e => setUnnestAction()} disabled={isDisabled} ><CancelPresentationIcon color={isDisabled ? 'grey' : "secondary"} /></IconButton>
                                </div>
                            </Tooltip>
                        </Grid>}

                        <Grid item xs={2} >
                            <Tooltip title="Delete Transaction" arrow>
                                <IconButton id="delete_transaction_btn" aria-label="delete_transaction_btn" onClick={e => setDeleteAction()} ><DeleteIcon color="secondary" /></IconButton>
                            </Tooltip>
                        </Grid>

                    </Grid>)}
                </Grid> */}

                {/* {action.action === 'create_transaction'         && <CreateTransaction onCompletion={e => { }} onClose={() => { setAction({}); dispatch(toggleRightDrawer()); }} setTabActive={setTabActive} />} */}
                {action.action === 'edit_transaction'           && <EditTransaction  onClose={e => { }} element={element} onCreateInvokedTransaction={onCreateInvokedTransaction}  />}
                {action.action === 'delete_transaction'         && <DeleteTransactionAlert onCompletion={onCompletion} element={element} onClose={() => { setAction({}); dispatch(toggleRightDrawer()); }} />}
                {action.action === 'unnest_transaction'         && <UnnestChildTransactionAlert onCompletion={onCompletion} element={element} onClose={() => { setAction({}); dispatch(toggleRightDrawer()); }} />}
            </TabPanel >

            {/* Transaction Nodes table */}
            {/* {isMainTransaction() && !isInvokedTransaction() && 
            <TabPanel value={value} index={1}>
                <BreadCrumb items={detailsBC} />
                <Divider style={marginBottomForBreadCrumb} />
                <EditTransactionNodes onCompletion={e => { }} onClose={e => { }} element={element} />
            </TabPanel>} */}

            {/* Events table */}
            {/* <TabPanel value={value} index={1}>
                {!bottomDrawerStatus && <>
                <Box><BreadCrumb items={detailsBC} /></Box>
                <Divider style={marginBottomForBreadCrumb} /> </>}
                <EventTable outgoing={true} incoming={true} transactionId={element.id} />
            </TabPanel> */}

            {/* Remap clusterlets */}
            {isMainTransaction() && 
            <TabPanel value={value} index={1}>
                <Box style={{height: '5px'}} />
                <RemapClusterlets selectedTransaction={element.id} onClose={() => { setAction({}) }} />
            </TabPanel> }

            {/* Advanced setup */}
            <TabPanel value={value} index={isMainTransaction() ? 2 : 1}>
                <Box style={{height: '5px'}} />
                <AdvancedSetup element={element}/>
            </TabPanel>
        </>
    )
}